import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { APP_CONFIG } from '../config/app-config';
import { AuthService } from '../auth/auth.service';

/** True when the outgoing request targets the RIPT API and should carry a bearer token. */
function isApiRequest(url: string, apiBaseUrl: string): boolean {
  return url.startsWith(apiBaseUrl) || url.includes('/api/');
}

/**
 * Attaches the MSAL-acquired bearer token to API requests (T-058, NFR-01, IP-03).
 * Non-API requests (assets, config) pass through untouched.
 */
export const msalInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(APP_CONFIG);
  if (!config.authEnabled || !isApiRequest(req.url, config.apiBaseUrl)) {
    return next(req);
  }
  const auth = inject(AuthService);
  return from(auth.acquireToken()).pipe(
    switchMap((token) => {
      const authReq = token
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;
      return next(authReq);
    }),
  );
};
